import React from 'react'
import Head from 'next/head'
import Home from 'modules/Site/Home'
import { GetServerSideProps, NextPage } from 'next'
import { useAccountSourceTrack } from 'hooks'
import { useCrisp } from 'plugins/crisp'
import { SiteLayout, SiteSEO, StructuredData } from 'components/site'
import { brandingUrl } from 'config/constants'
import { faqList } from 'modules/Site/Home/Faq/constant'
import { api } from 'plugins/ghost/ghost-client'
import { PostsOrPages } from '@tryghost/content-api'

interface Props {
  referer?: string
  posts?: PostsOrPages
}

const homeTitle = '浩客HowXM官网 - 数字化系统必备的应用内调研、评价、通知工具 - 简单好用的体验分析工具 - NPS调研工具'

const structuredData = [
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '浩客HowXM',
    legalName: '西安数据如金信息科技有限公司',
    url: brandingUrl,
    logo: `${brandingUrl}/logo.png`,
    email: 'support@howxm.com',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '浩客HowXM',
    url: brandingUrl,
    inLanguage: 'zh-CN',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: '浩客HowXM',
    applicationCategory: 'BusinessApplication',
    operatingSystem: 'Web, iOS, Android, WeChat Mini Program',
    url: brandingUrl,
    offers: { '@type': 'Offer', price: '0', priceCurrency: 'CNY' },
    description:
      '浩客HowXM 是应用内用户体验调研与反馈工具，支持在 Web、App、小程序中嵌入问卷、NPS 调研、满意度调研与通知，精准收集并分析用户反馈，优化用户体验。',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqList.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: { '@type': 'Answer', text: item.answer },
    })),
  },
]

const Site: NextPage<Props> = ({ referer, posts }) => {
  useAccountSourceTrack(referer)
  useCrisp()

  return (
    <SiteLayout>
      <SiteSEO title={homeTitle} />
      <StructuredData data={structuredData} />
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1.0"></meta>
        <style>
          {`body {
            min-width: unset !important;
          }`}
        </style>
      </Head>
      <Home posts={posts} />
    </SiteLayout>
  )
}
export const getServerSideProps: GetServerSideProps = async ({ req }) => {
  const referer = req?.headers.referer || null
  let posts = null
  try {
    posts = await api.posts.browse({
      filter: `tag:selected`,
      limit: 3,
      fields: ['id', 'title', 'excerpt', 'feature_image', 'feature_image_alt', 'url'],
    })
  } catch (e) {
    console.error(e)
  }

  return {
    props: {
      referer,
      posts,
    },
  }
}

export default Site
